import styled from 'styled-components';
import WebFont from 'webfontloader';
import theme from '../utils/theme';

WebFont.load({
    google: {
        families: ['Plus Jakarta Sans:wght@400;500;600;700;800', 'Inter:wght@400;500']
    }
});

const ContenedorInicio = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    width: 100%;
    background-color: ${theme.fondoOscuro};
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    padding: 60px 20px !important;
`;

/* Malla técnica sutil (estilo Vercel/Linear original, no genérica) */
const GridOverlay = styled.div`
    position: absolute;
    inset: 0;
    background-size: 40px 40px;
    background-image: 
        linear-gradient(to right, rgba(255, 255, 255, 0.03) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    
    /* Desvanecimiento únicamente horizontal (de izquierda a derecha) */
    mask-image: linear-gradient(
        to right, 
        transparent 0%, 
        #000 15%, 
        #000 85%, 
        transparent 100%
    );
    -webkit-mask-image: linear-gradient(
        to right, 
        transparent 0%, 
        #000 15%, 
        #000 85%, 
        transparent 100%
    );

    pointer-events: none;
`;

const ContenedorPequeno = styled.div`
    max-width: 820px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    z-index: 2;
    position: relative;
`;

const Badge = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px !important;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: ${theme.letraMutedOscura};
    font-size: 13px;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    margin-bottom: 28px !important;
    backdrop-filter: blur(8px);

    .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${theme.verde};
        box-shadow: 0 0 10px ${theme.verde};
    }
`;

const Titulo = styled.h1`
    font-size: 52px;
    font-weight: 800;
    color: ${theme.letraBlanca} !important;
    font-family: "Plus Jakarta Sans", sans-serif;
    line-height: 1.15;
    margin: 0 !important;
    letter-spacing: -0.03em;

    .highlight {
        /* Azul sólido de alto contraste con ligera variación de tono sin parecer degradado espacial */
        color: #60A5FA;
        font-weight: 800;
        display: inline-block;
    }

    @media screen and (max-width: 1024px) {
        font-size: 40px;
    }

    @media screen and (max-width: 600px) {
        font-size: 30px;
        line-height: 1.25;
    }
`;

const Subtitulo = styled.p`
    font-size: 18px;
    line-height: 1.6;
    color: ${theme.letraMutedOscura} !important;
    font-family: "Inter", sans-serif;
    max-width: 620px;
    margin-top: 22px !important;
    margin-bottom: 0 !important;
    font-weight: 400;

    strong {
        color: ${theme.letraBlanca};
        font-weight: 500;
    }

    @media screen and (max-width: 600px) {
        font-size: 15px;
    }
`;

const BotoneraHero = styled.div`
    display: flex;
    gap: 14px;
    margin-top: 32px !important;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 480px) {
        flex-direction: column;
        width: 100%;
    }
`;

const BotonPrimario = styled.a`
    background-color: ${theme.azulFuerte};
    color: ${theme.letraBlanca};
    padding: 12px 22px !important;
    border-radius: 8px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 150ms ease-in-out;
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover {
        background-color: ${theme.azulHover};
        transform: translateY(-1px);
    }

    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: center;
        box-sizing: border-box;
    }
`;

const BotonSecundario = styled.a`
    background-color: rgba(255, 255, 255, 0.03);
    color: ${theme.letraBlanca};
    padding: 12px 22px !important;
    border-radius: 8px;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    text-decoration: none;
    border: 1px solid rgba(255, 255, 255, 0.12);
    transition: all 150ms ease-in-out;

    &:hover {
        background-color: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.25);
    }

    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: center;
        box-sizing: border-box;
    }
`;

export { 
  ContenedorInicio, 
  GridOverlay,
  ContenedorPequeno, 
  Badge, 
  Titulo, 
  Subtitulo, 
  BotoneraHero, 
  BotonPrimario, 
  BotonSecundario 
};